import { ContainerModule } from 'inversify';
import { createI18nService, I18nInstance, I18nInstanceType } from '@framework/i18n';
import config from '@/dealroadshow/application/config/i18n';
import { loadErrorResources } from '@/dealroadshow/ui/translations/helpers/loadErrorResources';
import { TYPES } from '@framework/config/DI/types';

export const i18nModule: ContainerModule = new ContainerModule(({ bind }) => {
  bind<I18nInstanceType>(I18nInstance)
    .toDynamicValue(({ get }) => {
      const locale = get<string>(TYPES.Locale);

      return createI18nService({
        config,
        resources: loadErrorResources(),
        locale,
      });
    })
    .inSingletonScope();
});
